//https://tennisballcricket.com/getComments?MatchId=6866

import { slugify } from 'utils/misc';
import LoadingBar from 'components/LoadingBar';
import React, { useState, useEffect } from 'react';
import { Card, Table, Row, Col } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import ApiService from 'services';
import { getBowlingEconomy } from 'utils/misc';
import { getDrr } from 'utils/points';
import { getIdFromSlug } from 'utils/misc';
import { getTeamLink, getLiveScoreLink } from 'utils/links';

const MatchScoreCard = () => {

    const { matchSlug } = useParams();
    const [matchId, setMatchId] = useState(null);
    const [matchData, setMatchData] = useState([]);
    const [matchSummary, setMatchSummary] = useState([]);
    const [loading, setLoading] = React.useState(true);

    useEffect(() => {
        setMatchId(getIdFromSlug(matchSlug));
    }, [matchSlug]);
    useEffect(() => {
        const fetchData = async () => {
            try {

                Promise.all([
                    ApiService.getDetailedScoreCard(matchId),
                    ApiService.getDetailedScoreCardSummary(matchId)
                ])
                    .then(([scoreCard, summary]) => {
                        setMatchData(scoreCard);
                        setMatchSummary(summary);
                        //console.log(response);
                        setLoading(false);
                    });
            } catch (error) {
                // Handle error
                //
                console.log(error);
            }
        };
        if (matchId) {
            fetchData();
        }
    }, [matchId]);

    const getInningsTotal = (index) => {

        var sumball = matchData[index].Batting.reduce(function (previousValue, currentValue) {
            const previousBalls = parseInt(previousValue) || 0;
            const currentBalls = parseInt(currentValue?.BallFaced) || 0;
            return previousBalls + currentBalls;
        }, 0);



        return <>
            <td className='bold-text'>{matchData[index].Score[0].Score}</td>
            <td>{sumball}</td>
            <td colSpan='4'>{matchData[index].Score[0].Wicket + " Wickets; " + matchData[index].Score[0].Over + " Overs"} {"(" + getDrr(matchData[index].Score[0].Score, matchData[index].Score[0].TotOver).toFixed(2) + " r.p.o)"}</td>
        </>

    }
    const getInningsExtras = (origIndex) => {
        //index = 0 
        let index = (origIndex + 1) % 2;
        if (matchData && matchData.length > 0) {
            var sumB = 0;
            var sumT = 0;
            if (origIndex == 0) {
                sumB = parseInt((matchData[index].TeamByes) ? matchData[index].TeamByes.Team1Byes : "0");
            }
            else
                sumB = parseInt((matchData[index].TeamByes) ? matchData[index].TeamByes.Team2Byes : "0");

            var sumN = matchData[index].Bowler.reduce(function (previousValue, currentValue) {
                const previousNoballs = parseInt(previousValue) || 0;
                const currentNoballs = parseInt(currentValue?.Noballs) || 0;
                return previousNoballs + currentNoballs;
            }, 0);

            var sumwd = matchData[index].Bowler.reduce(function (previousValue, currentValue) {
                const previousWide = parseInt(previousValue) || 0;
                const currentWide = parseInt(currentValue?.Wide) || 0;
                return previousWide + currentWide;
            }, 0);
            sumT = (sumwd + sumN + sumB)
            return <><td>{sumT}</td><td colSpan={5}>{"( wd " + sumwd + ", nb " + sumN + ", b " + sumB + ")"}</td></>
        } else {
            return <></>
        }
    }
    const getBowlerExtras = (wides, noballs) => {
        try {
            let extras = "";
            if (parseInt(wides) > 0) {
                extras = extras + wides + " wd ";
            }
            if (parseInt(noballs) > 0) {
                extras = extras + noballs + " n ";
            }
            return extras.trim(); // Remove trailing space if any
        } catch (exception) {
            return "";
        }
    }
    const getDismissalLine = (data) => {
        if (data.HName.trim() === 'Did Not Bat') {
            return <></>
        }
        if (data.HName.trim() === 'Not Out') {
            return <span className='fw-bold'>{data.HName}</span>
        } else if (data.HName.trim() === 'Runout') {
            return <><span className='fw-bold'>{data.HName}</span> by <span dangerouslySetInnerHTML={{ __html: data.FielderName }} /></>
        } else if (data.HName) {
            return <><span className='fw-bold'>{data.HName}</span> <span dangerouslySetInnerHTML={{ __html: data.FielderName }} />
                <span className='fw-bold'>b</span> {data.BowlerName}</>
        } else {
            return <>
                <span className='fw-bold'>b</span> {data.BowlerName}
            </>
        }

    }
    const getTossDecision = () => {
        if (matchData && matchData.length > 0) {
            if (matchData[0].Toss.trim().length > 0) {
                return matchData[0].Toss;
            } else {
                return matchData[1].Toss;
            }
        } else {
            return <></>
        }
    }
    const getMOMPlayerName = (playerId) => {
        if (matchData && matchData.length > 0) {
            const player =
                matchData[0].Batting.find((batsMan) => playerId === batsMan.PlayerId) ||
                matchData[1].Batting.find((batsMan) => playerId === batsMan.PlayerId);
            return <> <a href={"/players/" + slugify(player?.FirstName) + "-" + player?.PlayerId}>

                <span dangerouslySetInnerHTML={{ __html: player.FirstName }} /></a></>

        } else {
            return <></>
        }
    }
    const getMatchSummary = () => {

        if (matchSummary.length === 0) {
            return <></>
        }
        const {
            TourName,
            MatchId,
            TotalOvers,
            Winner,
            Team1,
            Team2,
            PlayName,
            Date,
            MOM
        } = matchSummary[0];

        const matchWinner = Winner === '1' ? Team2 : Team1;

        return (
            <Card className="match-summary">
                <Card.Header>
                    {TourName} - Match Summary - Match ID: {MatchId}
                </Card.Header>
                <Card.Body>
                    <Card.Title>
                        {Team1.TeamName} vs {Team2.TeamName}
                    </Card.Title>
                    <Row className='mb-2'>
                        <Col>
                            {getTossDecision()}
                        </Col>
                        <Col>
                            { getLiveScoreLink(MatchId)}
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={3}>
                            <strong>Date: </strong>

                            {Date}
                        </Col>
                        <Col xs={12} md={3}>
                            <strong>Ground Name: </strong>

                            {PlayName}
                        </Col>
                        <Col xs={12} md={3}>
                            <strong>Match Winner: </strong>
                            {getTeamLink(matchWinner.TeamName, matchWinner.TeamId)}
                        </Col>


                        <Col xs={12} md={3}>
                            <strong>Total Overs: </strong>

                            {TotalOvers}
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={6}>
                            <strong>Man of the Match: </strong>

                            {getMOMPlayerName(MOM)}
                        </Col>
                        <Col xs={12} md={6}>
                            <strong>Umpires: </strong>
                            <span className='show-block'>
                                <a href={"/players/" + slugify(matchData[0].Ump.UmpPlayer1) + "-" + matchData[0].Ump.UmpiringPlayerId1}>{matchData[0].Ump.UmpPlayer1}</a> ({matchData[0].Ump.UmpTeam1}) &amp; &nbsp;
                                 <a href={"/players/" + slugify(matchData[0].Ump.UmpPlayer2) + "-" + matchData[0].Ump.UmpiringPlayerId2}>{matchData[0].Ump.UmpPlayer2}</a> ({matchData[0].Ump.UmpTeam2})</span>

                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        );

    }
    const displayBatting = (index) => {
        if (matchData && matchData.length > 0) {


            return <><Card key={index} className="mb-4">
                <Card.Header>{matchData[index].Batting[index].TeamName} Batting</Card.Header>
                <Card.Body>

                    <Table size="sm" responsive striped bordered hover>
                        <thead>
                            <tr>
                                <th>Player</th>
                                <th>Runs</th>
                                <th>Balls Faced</th>
                                <th>Fours</th>
                                <th>Sixes</th>
                                <th>Dismissal</th>
                                <th>Strike Rate</th>
                            </tr>
                        </thead>
                        <tbody>
                            {matchData[index].Batting.map((player, playerIndex) => (
                                <tr key={playerIndex}>
                                    {player.HName !== 'Did Not Bat ' && (
                                        <>
                                            <td>

                                                <a href={"/players/" + slugify(player?.FirstName) + "-" + player?.PlayerId}>

                                                    <span dangerouslySetInnerHTML={{ __html: player.FirstName }} /></a>
                                            </td>
                                            <td>{player.RunScored}</td>
                                            <td>{player.BallFaced}</td>
                                            <td>{player.Four}</td>
                                            <td>{player.Six}</td>
                                            <td>
                                                {getDismissalLine(player)}

                                            </td>
                                            <td>{player.SR}</td>
                                        </>
                                    )}
                                </tr>
                            ))}
                            <tr>
                                {/** Display Extras line */}
                                <td>Extras: </td>{getInningsExtras(index)}
                            </tr>
                            <tr>
                                <td>Total: </td>{getInningsTotal(index)}
                            </tr>
                        </tbody>
                    </Table>

                    {matchData[index].Batting.filter((player) => {
                        return player.HName === 'Did Not Bat ';
                    }).length > 0 &&
                        <p>
                            <p>Did Not Bat:</p>
                            {' '}
                            {matchData[index].Batting.filter((player) => {
                                return player.HName === 'Did Not Bat ';
                            }).map((player, playerIndex) => (
                                player.HName === 'Did Not Bat ' && (
                                    <span key={playerIndex}>
                                        {playerIndex > 0 && ', '}
                                        <a href={"/players/" + slugify(player?.FirstName) + "-" + player?.PlayerId}>

                                            <span dangerouslySetInnerHTML={{ __html: player.FirstName }} /></a>
                                    </span>
                                )
                            ))}
                        </p>

                    }
                </Card.Body>
            </Card>
            </>
        } else {
            return <></>
        }
    }
    const displayFOW = (index) => {
        if (matchData && matchData.length > 0) {
            return <Card key={`fow-${index}`} className="mb-4">
                <Card.Header>Fall of Wickets</Card.Header>
                <Card.Body>
                    <p>{matchData[index].FOW}</p>
                </Card.Body>
            </Card>
        } else {
            return <></>
        }
    }
    const displayBowling = (index) => {

        if (matchData && matchData.length > 0) {
            return <Card key={`bowling-${index}`} className="mb-4">
                <Card.Header>{matchData[index].Batting[0].TeamName} Bowling</Card.Header>
                <Card.Body>
                    <Table size="sm" responsive striped bordered hover>
                        <thead>
                            <tr>
                                <th>Bowler</th>
                                <th>Overs</th>
                                <th>Maidens</th>
                                <th>Runs</th>
                                <th>Wickets</th>
                                <th>Econ</th>
                                <th>Extras</th>

                            </tr>
                        </thead>
                        <tbody>
                            {matchData[index].Bowler.map((bowler, bowlerIndex) => (
                                <tr key={bowlerIndex}>
                                    <td> <a href={`/players/${bowler.PlayerId}`}>{bowler.FirstName}</a></td>
                                    <td>{bowler.Overs}</td>
                                    <td>{bowler.Maidens}</td>
                                    <td>{bowler.Runs}</td>
                                    <td>{bowler.Wickets}</td>
                                    <td>{getBowlingEconomy({ Runs: bowler.Runs, Overs: bowler.Overs })}</td>
                                    <td>{getBowlerExtras(bowler.Wide, bowler.Noballs)}</td>

                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>
        } else {
            return <></>
        }


    }
    if (loading) {
        return <LoadingBar show={loading} />
    }
    return (
        <div>
            <div className="mb-3">
                {getMatchSummary()}
            </div>
            <div>
                {displayBatting(0)}
                {displayFOW(0)}
                {displayBowling(1)}

                {displayBatting(1)}
                {displayFOW(1)}
                {displayBowling(0)}
                {/**
                {displayExtras(0)}
                {displayDidNotBat(0)}
               
                {displayExtras(1)}
                {displayDidNotBat(1)}
               
                 **/}
            </div>



            {matchData && matchData.length > 0 &&
                <Card className="mb-4">
                    <Card.Header>Metadata</Card.Header>
                    <Card.Body>
                        <p>Entered by: {matchData[0]?.Publish.PublishName}</p>
                        <p>Date: {matchData[0]?.Publish.PublishDate}</p>
                    </Card.Body>
                </Card>
            }
        </div>
    );
};

export default MatchScoreCard;
